import { render, staticRenderFns } from "./StripeConnectButton.vue?vue&type=template&id=d8c05070"
import script from "./StripeConnectButton.vue?vue&type=script&lang=js"
export * from "./StripeConnectButton.vue?vue&type=script&lang=js"
import style0 from "./StripeConnectButton.vue?vue&type=style&index=0&id=d8c05070&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports